export const colors = [
  '#9C27B0',
  '#2196F3',
  '#FF5722',
  '#FF9800',
  '#00BCD4',
  '#673AB7',
  '#4CAF50',
  '#E91E63',
  '#009688',
  '#F44336', // End of originally picked color set.  These are the favorites
  '#A4E43F',
  '#F2510E',
  '#651BE6',
  '#61DA5E',
  '#CD2F00',
  '#9348AF',
  '#01AC53',
  '#C5A4FB',
  '#996635',
  '#B11573',
]
